import React from "react";

interface Booking {
  id: number;
  date: string;
  time: string;
  customer: string;
  email: string;
  mobile: string;
  staff: string;
  status: string;
  amount: string;
}

interface RecentBookingsProps {
  bookings: Booking[];
  currencySymbol?: string;
}

const getStatusClasses = (status: string) => {
  switch (status.toLowerCase()) {
    case "confirmed":
    case "approved":
    case "booked":
      return "bg-green-100 text-green-700";
    case "pending":
    case "assigned_pending":
      return "bg-yellow-100 text-yellow-700";
    case "completed":
      return "bg-purple-100 text-purple-700";
    case "in_progress":
      return "bg-blue-100 text-blue-700";
    case "canceled":
    case "cancelled":
      return "bg-red-100 text-red-700";
    default:
      return "bg-gray-100 text-gray-700";
  }
};

const formatStatus = (status: string) => {
  return status
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const RecentBookings = ({ bookings }: RecentBookingsProps) => {
  // Show only the top 5 latest bookings
  const displayedBookings = bookings.slice(0, 5);

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <h2 className="text-lg font-semibold text-[#402B69] mb-4">
        Recent Bookings
      </h2>
      <div className="space-y-3">
        {displayedBookings.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            No recent bookings found
          </div>
        ) : (
          displayedBookings.map((b) => (
            <div
              key={b.id}
              className="p-4 rounded-lg bg-[#F9F9F9] hover:bg-[#EDE3F7] transition"
            >
              {/* Top Row: Customer Name and Amount */}
              <div className="flex items-start justify-between mb-3">
                <div className="flex-1">
                  <p className="font-semibold text-[#1E1E1E] text-base">
                    {b.customer}
                  </p>
                  <p className="text-sm text-gray-600 mt-1">{b.email}</p>
                  <p className="text-sm text-gray-600">{b.mobile}</p>
                </div>
                <div className="text-right">
                  <p className="font-bold text-[#402B69] text-lg">{b.amount}</p>
                  <span
                    className={`text-xs px-2 py-1 rounded-full font-medium inline-block mt-1 ${getStatusClasses(
                      b.status
                    )}`}
                  >
                    {formatStatus(b.status)}
                  </span>
                </div>
              </div>

              {/* Bottom Row: Date and Time */}
              <div className="flex items-center justify-end text-sm">
                {/* <p className="text-[#885ABB] font-medium">
                  Staff: {b.staff}
                </p> */}
                <div className="flex items-center gap-3 text-gray-600">
                  <span>{b.date}</span>
                  <span>•</span>
                  <span>{b.time}</span>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RecentBookings;
